import React from 'react';
import {  } from 'antd';
import { IListItem } from '@pro/activity/testerClub/interface'

type IProps = {
    className?: string;
    product: IListItem;
}

const ProductTags: React.FC<IProps> = (props) => {
    const { className, product } = props

    return(
        <div className={className}>
            {product.tags?.map((item) => {
                return (
                    <span key={item} className={'g-tag'}>{item}</span>
                )
            })}
        </div>
    );
};

export default ProductTags